import { produce } from 'immer';
import { SubflowMessengerAction } from 'lib-shared-types-api';

import { FlowNodeTypes } from 'components/powerFlowShared/components/types';
import { FlowT } from 'hocs/flows/api/types';

import { FlowMessengerAction } from '../flow.types';

/**
 * This function is used to format the subflow nodes that are fetched from the
 * backend for the subflow editor.
 */
export function formatSubflowNodesForSubflowEditor(
  presistedFlow: FlowT<FlowMessengerAction, SubflowMessengerAction>,
): FlowT<FlowMessengerAction, SubflowMessengerAction> {
  return produce(presistedFlow, (draft) => {
    draft.subflows?.forEach((subflow) => {
      // All subflows are active in the subflow editor, but this property may not be persisted.
      subflow.active = true;

      // substitute the subflowInit node with init node in all subflows.
      subflow.actions = subflow.actions.map((node) => {
        if ((node.nodeType as FlowNodeTypes) === FlowNodeTypes.SUBFLOW_INIT) {
          node.nodeType = FlowNodeTypes.INIT;
        }
        return node;
      });
    });

    return draft;
  });
}
